import { FC } from 'react';
import { LABEL_CONSTANTS } from '../../constants/common';
import { TankMaintenanceDueStatus } from '../../types/interfaces/accountTankMaintenance.interfaces';
import './tankMaintenance.scss';

type TankDueBadgeProps = {
  status: TankMaintenanceDueStatus;
  daysUntilDue?: number;
};

const TankDueBadge: FC<TankDueBadgeProps> = ({ status, daysUntilDue }): JSX.Element | null => {
  if (status !== 'due' && status !== 'overdue') {
    return null;
  }

  const label =
    status === 'overdue'
      ? daysUntilDue !== undefined
        ? `${LABEL_CONSTANTS.OVERDUE} (${Math.abs(daysUntilDue)}d)`
        : LABEL_CONSTANTS.OVERDUE
      : daysUntilDue !== undefined
      ? `${LABEL_CONSTANTS.DUE} (${daysUntilDue}d)`
      : LABEL_CONSTANTS.DUE;

  return <span className={`tank-due-badge tank-due-badge--${status}`}>{label}</span>;
};

export default TankDueBadge;
